import { createFileRoute } from "@tanstack/react-router";

import { RouteLink, WhatsAppLink } from "@/components/site/ctas";
import { Reveal } from "@/components/site/motion";
import { getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/rfq/received")({
  validateSearch: (search: Record<string, unknown>) => ({ ref: typeof search.ref === "string" ? search.ref : "" }),
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.rfq.received.title} · insidermark` }, { name: "robots", content: "noindex" }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const { ref } = Route.useSearch();
  const t = getDict(lang);
  const r = t.rfq.received;
  return (
    <main>
      <header className="im-page-head">
        <div className="im-plate im-plate--manifest" aria-hidden="true" />
        <div className="im-wrap im-rel">
          <Reveal>
            {ref ? (
              <p className="im-eyebrow">
                {r.ref} {ref}
              </p>
            ) : null}
            <h1 className="im-display mt-4 max-w-[14ch]">{r.title}</h1>
            <p className="im-body-text mt-5">{r.body}</p>
          </Reveal>
        </div>
      </header>
      <section className="im-section im-section--tight">
        <div className="im-wrap im-two">
          <ol className="im-steps">
            {r.steps.map((s) => (
              <li key={s}>
                <span>{s}</span>
              </li>
            ))}
          </ol>
          <div className="flex flex-col items-start gap-6">
            <WhatsAppLink label={t.nav.whatsapp} text={ref ? `Insidermark ${ref}` : undefined} />
            <RouteLink to={href(lang)}>{r.home}</RouteLink>
          </div>
        </div>
      </section>
    </main>
  );
}
